import { post } from 'utilities/APIRequestHelper';
import { serviceErrorMapper } from 'components/shared/XpressId/utils/serviceErrorMapper';
import { serviceResponseMapper } from 'components/shared/XpressId/utils/serviceResponseMapper';
import Api from 'services/api';
import apiURLBuilder from 'core/apiURLBuilder';

export const fetchAccessToken = async ({ operationModes, redirectionUrl, faceMatch, acceptedText, language }) => {
    const params = {
        query: { operationModes, redirectionUrl, faceMatch, acceptedText, language },
        header: {},
    };
    try {
        const response = await post('startDocumentCapture', params, {});

        return serviceResponseMapper(response);
    } catch (error) {
        return serviceErrorMapper(error);
    }
};

export const recoverAccessToken = async (clientId, token) => {
    try {
        const url = apiURLBuilder.getURL('recoverDocumentCapture', {
            clientId,
            token,
        });
        const response = await Api.get(url);

        return serviceResponseMapper(response);
    } catch (error) {
        return serviceErrorMapper(error);
    }
};

export const revokeAccessToken = async () => {
    try {
        return await post('revokeAccessDocumentCapture');
    } catch (error) {
        return error;
    }
};

export const postFinishCapture = async () => {
    try {
        const response = await post('finishDocumentCapture', {}, {});

        return serviceResponseMapper(response);
    } catch (error) {
        return serviceErrorMapper(error);
    }
};

export const postCaptureEvent = async data => {
    try {
        const params = {
            query: data,
            header: {},
        };

        return await post('saveDocumentCaptureEvent', params, {});
    } catch (error) {
        return error;
    }
};
export const postCaptureEventWithToken = async (token, clientId, data) => {
    try {
        const params = {
            query: data,
            header: {},
        };
        const url = apiURLBuilder.getURL('saveDocumentCaptureEventWithToken', {
            clientId,
            token,
        });

        return await Api.post(url, params);
    } catch (error) {
        return error;
    }
};
